import React, { useEffect, useState } from "react";
import ProfileComponent from "./ProfileComponent/ProfileComponent";
import TabsComponent from "./TabsComponent/TabsComponent";
import { IServiceUser } from "./Interfaces/IServiceUser";
import { Col, Row, Button } from "antd";
import commonStyles from "../DashBoard/DashBoard.module.scss";
import commonMobileStyles from "../DashBoard/DashBoardMobile/DashBoardMobile.module.scss";
import { ServiceUsersContext } from "../../context/ServiceUsersContext";
import { getTrustedContactsByPersonId } from "../../services/RegistrationService";
import { useHistory } from "react-router-dom";
import GoogleLoader from "../../assets/Loader/GoogleSvgLoader/GoogleLoader";
import { backArrowIcon, scheduleServiceRightArrow } from "../../assets/images";
import CustomButton from "../../common/Buttons/CustomButton";
import styles from "./ServiceUsers.module.scss";
import { usePaginationCtx } from "../../context/PaginationContext";
import MobileServicesListView from "../Shared/MobileServicesListView";
import { useTripsCtx } from "../../context/TripDetailsContext";
import { usePersonSummaryCtx } from "../../context/PersonSummaryContext";
import { TrackAnalytics } from "../../types/ApplicationTypes";

interface Props {
  serviceUser: IServiceUser;
  isLoaded: boolean;
  personId: number;
  parentPersonId: number;
}

const ServiceUsers: React.FC<Props> = ({
  serviceUser,
  isLoaded,
  parentPersonId,
  personId,
}) => {
  const [trustedContactCount, setTrustedContactCount] = useState<number>(0);
  const history = useHistory();

  const { isLoadingPersonData } = usePersonSummaryCtx();

  const { resetPagination, activeTabCtx, showCanceledCtx } = usePaginationCtx();
  const [, setActiveTab] = activeTabCtx;

  const { totalServiceCountCtx } = useTripsCtx();

  const [totalServiceCount] = totalServiceCountCtx;

  const { state, dispatch } = React.useContext(ServiceUsersContext);

  useEffect(() => {
    getTrustedContacts(personId);
  }, [serviceUser]);

  async function getTrustedContacts(id: number) {
    const trustedContacts = await getTrustedContactsByPersonId(id);
    setTrustedContactCount(trustedContacts.length);
  }

  const redirect = (url: string) => {
    resetPagination();
    history.push(url);
  };

  const handleBack = () => redirect("/DashBoard");

  const handleScheduleAServiceButtonClick = () => {
    TrackAnalytics(
      "/DashBoard/ManageServiceUsers",
      "Schedule a Service - SU Profile",
      "Service User Profile Page"
    );
    redirect(
      `/DashBoard/ScheduleService/ScheduleServiceCalender/${parentPersonId}/${personId}`
    );
  };

  const handleTabChange = (service: string) => {
    service === "upcoming" && setActiveTab("1");
    service === "past" && setActiveTab("2");
    service === "favorite" && setActiveTab("3");
  };

  const links = [
    {
      to: `/DashBoard/ManageServiceUsersMobile/${personId}/${parentPersonId}/upcomingServices`,
      text: `Upcoming Services (${totalServiceCount["1"]})`,
      onClick: () => handleTabChange("upcoming"),
    },
    {
      to: `/DashBoard/ManageServiceUsersMobile/${personId}/${parentPersonId}/pastServices`,
      text: "Past Services",
      onClick: () => handleTabChange("past"),
    },
    {
      to: `/DashBoard/ManageServiceUsersMobile/${personId}/${parentPersonId}/favoriteServices`,
      text: "Favorites",
      onClick: () => handleTabChange("favorite"),
    },
    {
      to: `/DashBoard/TrustedContactMobilePage/${personId}/${serviceUser.firstName} ${serviceUser.lastName}`,
      text: `Trusted Contacts (${trustedContactCount})`,
      onClick: () => {},
    },
  ];

  return (
    <>
      <Row>
        <Col span={2} />
        <Col span={20}>
          <Row gutter={[0, 25]} className={styles.btnsAlign}>
            <Col span={24} xs={{ order: 2 }} lg={{ order: 1 }}>
              <CustomButton
                text="Back"
                handlerFunction={handleBack}
                type="link"
                icon={backArrowIcon}
                className="backBtn"
              />
            </Col>
            <Col
              className={commonStyles.noRipple}
              xs={{ order: 1 }}
              lg={{ order: 2 }}
            >
              <Button
                onClick={handleScheduleAServiceButtonClick}
                className={commonStyles.desktopAddServiceRequestBtn}
              >
                Schedule a Service
                <img
                  src={scheduleServiceRightArrow}
                  className={commonStyles.scheduleServiceImage}
                />
              </Button>
            </Col>
            <Col xs={{ span: 24, order: 3 }} lg={0} />
          </Row>

          <Row justify="center">
            <Col xs={24} lg={6}>
              {isLoadingPersonData || isLoaded ? (
                <GoogleLoader />
              ) : (
                <ProfileComponent user={serviceUser} />
              )}
            </Col>
            <Col xs={0} lg={18}>
              <TabsComponent
                serviceUserName={`${serviceUser.firstName} ${serviceUser.lastName} `}
                dispatch={dispatch}
                personId={personId}
                parentPersonId={parentPersonId}
                trustedContactCount={trustedContactCount}
              />
            </Col>
            <Col xs={24} lg={0} className={commonMobileStyles.serviceContainer}>
              <MobileServicesListView links={links} />
            </Col>
          </Row>
        </Col>
        <Col span={2} />
      </Row>
    </>
  );
};

export default ServiceUsers;
